import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetVolumeBot } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl5 + 'chatbot-volume';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    var arrayfill = ["#F56954","#F39C12","#FFC107"]
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get("chatbot-volume")
        var x = []
        for (var i = 0; i < data.size; i++) {
            var datinti = data.get(i)
            var topic = datinti.get("hari")
            var total = parseInt(datinti.get("volume-chatbot"))
            if(topic==""){
                topic = "No Topic"
                total = 1
            }
            var obj = { name: topic }
            obj["Volume ChatBot"] = total 
            obj["fill"] = arrayfill[i]
            obj["stroke"] = arrayfill[i]
            x.push(obj)

        }
        data = x
    }
    dispatch({ type: GetVolumeBot, data: data });
    return data
};